<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BFormInput,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';
import ItemModal from '@/views/app/operacoes/picitem/list/ModalBuscarItens.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BFormInput,
    BModal,
    BButton,
    BAlert,
    vSelect,
    ItemModal,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    picid: {
      type: Number,
      default: null,
      require: false,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiitem: null,
      quantity: '',
      discount: '',
      valor: '',
      visibleValor: false,
      isLoading: false,
    };
  },
  computed: {
    disableDiscount() {
      return !!this.valor; // Desabilita o campo de desconto se "valor" for preenchido
    },
    disableValor() {
      return !!this.discount; // Desabilita o campo de valor se "desconto" for preenchido
    },
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      this.isLoading = true;
      console.log('validateForm');
      try {
        // Emit the 'ok' event
        // Hide the modal
        this.$bvModal.hide(this.idModal);
        console.log({
          picid: this.picid,
          items: this.dataFromApiitem,
          picitemquantidade: this.quantity,
          picitemquantidadesaldo: this.quantity,
          picitemvalorpic: this.valor,
          picitemporcentagem: this.discount,
          picitemsituacao: 'Pendente',
          picitemtotalmercadoria: 0,
        });
        // Make the API request
        await axios.post('/pic-item', {
          picid: this.picid,
          items: this.dataFromApiitem,
          picitemquantidade: this.quantity,
          picitemquantidadesaldo: this.quantity,
          picitemvalorpic: this.valor,
          picitemporcentagem: this.discount,
          picitemsituacao: 'Pendente',
          picitemtotalmercadoria: 0,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Item cadastrado com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });

        this.$emit('ok');
      } catch (error) {
        // Handle the error; ensure this.error.message is correctly implemented
        console.log(error);
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },

    showModal(items) {
      this.dataFromApiitem = items;
      if (this.dataFromApiitem.length < 2) {
        this.visibleValor = true;
      }
      this.$refs.quantityDiscountModal.show();
    },
  },
};
</script>

<template>
  <b-modal no-close-on-backdrop no-close-on-esc ref="quantityDiscountModal" size="md" :id="idModal" :title="titleModal"
    :ok-title="labelBtnOk" ok-variant="success" cancel-variant="secondary" body-bg-variant="light"
    cancel-title="Cancelar" @ok="validateForm" @cancel="$emit('cancel')" @close="$emit('cancel')">
    <validation-observer ref="refFormData">

      <b-form>
        <b-row>
          <b-form-group class="col-12" label="Quantidade (Por Item)" label-for="input-quantidade">
            <b-form-input id="input-quantidade" v-model="quantity" type="number" min="1" required></b-form-input>
          </b-form-group>
          <b-form-group v-if="visibleValor" class="col-12" label="Valor" label-for="input-valor">
            <b-form-input id="input-valor" :disabled="disableValor" v-model="valor" type="number" min="0" max="100"
              step="0.01" required></b-form-input>
          </b-form-group>
          <b-form-group class="col-12" label="Porcentagem de Desconto" label-for="input-desconto">
            <b-form-input id="input-desconto" :disabled="disableDiscount" v-model="discount" type="number" min="0"
              max="100" step="0.01" required></b-form-input>
          </b-form-group>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
